import "../../App.css";
import { Routes, Route } from "react-router-dom";
import Nopage from "../Nopage/Nopage";
import LandingPagesLayout from "./Layout/Layout";
import NotificationsPage from "../userDashboard/Notifications/Notifications";
import StartPage from "./Start/Start";
import ScrollToTop from "../../utils/scrollToTop";
import OnlinePayment from "./Start/OnlinePayment";
import PrivacyPolicyPage from "./Start/PrivacyPolicy";
import DeleteAccountPage from "./Start/DeleteAccountPage";
import DeleteAccountInfoPage from "./Start/DeleteAccountInfoPage";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PaymentResultPage from "./Start/PaymentConfirmation";

const ExplorePagesRoute = () => {
  const scrollToTop = ScrollToTop();

  return (
    <PayPalScriptProvider
      options={{
        clientId:
          process.env.REACT_APP_PAYPAL_CLIENT_ID ||
          "AXFRrgLA_HV_swzDt00hKI5fQgXBj5w9izKPa8Fa4Q0YnXEJMpu-hs1RFAmfIsNLOVcDKeLjRxJEbhY_",
      }}
    >
      <Routes>
        <Route path="/" element={<LandingPagesLayout />}>
          <Route index element={<StartPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route
            path="/delete-account-info"
            element={<DeleteAccountInfoPage />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/online-payment" element={<OnlinePayment />} />
          <Route path="/payment-confirmation" element={<PaymentResultPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="*" element={<Nopage />} />
        </Route>
      </Routes>
    </PayPalScriptProvider>
  );
};

export default ExplorePagesRoute;
